import { render, staticRenderFns } from "./agenda-hierarchy-item-component.vue?vue&type=template&id=641a279a&scoped=true"
import script from "./agenda-hierarchy-item-component.ts?vue&type=script&lang=ts&external"
export * from "./agenda-hierarchy-item-component.ts?vue&type=script&lang=ts&external"
import style0 from "./agenda-hierarchy-item-component.scss?vue&type=style&index=0&id=641a279a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a279a",
  null
  
)

export default component.exports